import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, numberAttribute, signal } from '@angular/core';
import { timer } from 'rxjs';

@Component({
    selector: 'vz-loading',
    template: `
        <div class="fit layout center-center" [class.fixed]="global()" [style.z-index]="zIndex()">
            @if (visible()) {
                <div class="vz-backdrop-bg layout fit"></div>
                <div class="loader {{ sizeMap[size()] }}"></div>
                @if (text(); as t) {
                    <div class="loader-text">{{ t }}</div>
                }
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
    readonly size    = input<'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'>('l')
    readonly global  = input<boolean>(false);
    readonly text    = input<string>();
    readonly zIndex  = input<number | string>(2000);
    readonly defer   = input<number, unknown>(300, { transform: numberAttribute });

    readonly visible = signal<boolean>(false)
    readonly sizeMap = { xs: 'micro', s: 'tiny', m: 'small2', l: 'small', xl:  'medium', xxl: '' };

    _destroy = inject(DestroyRef);
    _ = effect(() => {
        if (!this.visible()) {
            const delay = this.defer() ?? 300;
            if (delay <= 0) {
                this.visible.set(true);
            }
            else {
                const s = timer(delay).subscribe(() => this.visible.set(true));
                this._destroy.onDestroy(() => s?.unsubscribe());
            }
        }
    });
}
